import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import { ILoginForm } from "../../interfaces/components/forms/login";

export const tokenApi = async (props: ILoginForm) => {
  return await axiosInstance.post(AXIOS_ROUTES.auth.login, props);
};

export const getUserInfoApi = async () => {
  return await axiosInstance.get(AXIOS_ROUTES.auth.userInfo);
};

export const forgotPasswordApi = async (email: string) => {
  return await axiosInstance.post(AXIOS_ROUTES.auth.forgotPassword, { email });
};
